import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class TmsWebBaseDragAndDropService extends BaseService {
  constructor(baseRoute: string) {
    super(baseRoute);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
